import { MusicalNoteIcon, PhotoIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Handle, Position, type NodeProps } from '@xyflow/react';

import CanvasPreviewImage from './CanvasPreviewImage';
import type { ClipCanvasNode, MediaResourceNodeData } from '../types';

type MediaResourceNodeProps = NodeProps<ClipCanvasNode>;

export default function MediaResourceNode({ id, data }: MediaResourceNodeProps) {
  if (data.kind !== 'media-resource') return null;
  const nodeData = data as MediaResourceNodeData;
  const Icon = nodeData.mediaType === 'image' ? PhotoIcon : MusicalNoteIcon;
  const referenceHandleClass = nodeData.mediaType === 'audio'
    ? 'clip-canvas-media-resource__handle clip-canvas-media-resource__handle--audio'
    : 'clip-canvas-media-resource__handle clip-canvas-media-resource__handle--image';

  return (
    <div className="clip-canvas-node clip-canvas-node--media-resource">
      <Handle type="target" position={Position.Left} />
      <Handle
        id={`reference:${nodeData.mediaType}`}
        type="source"
        position={Position.Right}
        className={referenceHandleClass}
        title={nodeData.mediaType === 'audio' ? '音频输出' : '图片输出'}
      />
      <div className="clip-canvas-node__topline">
        <div className="clip-canvas-node__header clip-canvas-node__header--inline">
          <Icon className="clip-canvas-node__icon" />
          <span>{nodeData.title}</span>
        </div>
        <button
          type="button"
          className="clip-canvas-node__icon-button clip-canvas-node__icon-button--danger nodrag nopan"
          onClick={(event) => {
            event.stopPropagation();
            void nodeData.actions?.onDeleteMediaResourceNode?.(id);
          }}
          aria-label={`删除资源 ${nodeData.title}`}
          title={`删除资源 ${nodeData.title}`}
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      </div>
      <div className="clip-canvas-media-resource__source">{nodeData.sourceLabel}</div>
      {nodeData.mediaType === 'image' ? (
        <div className="clip-canvas-media-resource__preview">
          <CanvasPreviewImage src={nodeData.url} alt={nodeData.title} />
        </div>
      ) : (
        <div className="clip-canvas-media-resource__audio nodrag nopan nowheel">
          <audio src={nodeData.url} controls />
        </div>
      )}
      {nodeData.prompt && (
        <div className="clip-canvas-media-resource__prompt">{nodeData.prompt}</div>
      )}
    </div>
  );
}
